import React from "react";
import { LandingNav } from "@/components/marketing/landing/LandingNav";
import { LandingHero } from "@/components/marketing/landing/LandingHero";
import { WalkthroughVideo } from "@/components/marketing/landing/WalkthroughVideo";
import { SocialProof } from "@/components/marketing/landing/SocialProof";
import { HowItWorks } from "@/components/marketing/landing/HowItWorks";
import { LiveActivity } from "@/components/marketing/landing/LiveActivity";
import { WhyHosts } from "@/components/marketing/landing/WhyHosts";
import { RiskFactors } from "@/components/marketing/landing/RiskFactors";
import { LandingPricing } from "@/components/marketing/landing/LandingPricing";
import { LandingFAQ } from "@/components/marketing/landing/LandingFAQ";
import { LandingCTA } from "@/components/marketing/landing/LandingCTA";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { ExitIntentModal } from "@/components/marketing/landing/ExitIntentModal";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background">
      <LandingNav />
      <LandingHero />
      <WalkthroughVideo />
      <SocialProof />
      <HowItWorks />
      <LiveActivity />
      <WhyHosts />
      <RiskFactors />
      <LandingPricing />
      <LandingFAQ />
      <LandingCTA />
      <MarketingFooter />
      <ExitIntentModal />
    </div>
  );
}
